// extracted by mini-css-extract-plugin
export var card = "card-module--card--SuUM2";
export var image = "card-module--image--2ZO+m";
export var textContainer = "card-module--textContainer--PS10g";
export var noHover = "card-module--noHover--x1gOf";
export var light = "card-module--light--w+H-q";
export var border = "card-module--border--Os-9p";
export var outline = "card-module--outline--MhZvg";
export var shadow = "card-module--shadow--rfW9D";